import script from "./UiField.vue?vue&type=script&setup=true&lang=js"
export * from "./UiField.vue?vue&type=script&setup=true&lang=js"

import "./UiField.vue?vue&type=style&index=0&id=78396493&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78396493"]])

export default __exports__